import * as Yup from 'yup'

export const schemaStep2 = (t: (key: string) => string) => ({
  reason: Yup.string().required(t('requiredMessage')),
  comment: Yup.string(),
})
